// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"template_scroll-black__8x3ba","title":"template_title__KJu3V"};